import React from 'react';
import Layout from '../components/Layout/Layout';
import EmailTicketSettings from '../components/email_ticket_system/EmailTicketSettings';

const EmailSettingsPage = () => {
    return (
        <Layout noSidebar={true}>
            <EmailTicketSettings />
        </Layout>
    );
};

export default EmailSettingsPage;
